import { Navigate, Outlet } from "react-router";
import { useAuth } from "../hooks/useAuth";

export function AdminRoute() {
  const { isAuthenticated, isInitialized, isAdmin } = useAuth();

  if (!isInitialized || !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
